import {Menu, MenuButton, MenuItem, MenuItems, Transition} from '@headlessui/react';
import {Fragment} from 'react';

import Icon from '@/components/icon';

export type SortOptionT = {
  label: string;
  value: 'created_at' | 'title' | 'type' | 'status';
  direction: 'asc' | 'desc';
};

type SortDropdownProps = {
  currentSort: SortOptionT;
  onSortChange: (option: SortOptionT) => void;
};

const sortOptions: SortOptionT[] = [
  {label: 'Newest First', value: 'created_at', direction: 'desc'},
  {label: 'Oldest First', value: 'created_at', direction: 'asc'},
  {label: 'Title (A-Z)', value: 'title', direction: 'asc'},
  {label: 'Title (Z-A)', value: 'title', direction: 'desc'},
  {label: 'Type', value: 'type', direction: 'asc'},
  {label: 'Status', value: 'status', direction: 'asc'},
];

export function SortDropdown({currentSort, onSortChange}: SortDropdownProps) {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <MenuButton className="flex items-center gap-2 rounded-md bg-gray-700/50 px-3 py-2 text-sm font-medium text-gray-200 hover:bg-gray-700/70">
        <Icon name="arrow-down-up" className="h-4 w-4 text-gray-200" />
        Sort: {currentSort.label}
      </MenuButton>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <MenuItems className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-gray-800 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            {sortOptions.map(option => (
              <MenuItem key={`${option.value}-${option.direction}`}>
                {({focus}) => (
                  <button
                    onClick={() => onSortChange(option)}
                    className={`${focus ? 'bg-gray-700/70 text-white' : 'text-gray-200'} ${
                      option.value === currentSort.value && option.direction === currentSort.direction
                        ? 'bg-primary/20 font-medium text-primary'
                        : ''
                    } group flex w-full items-center px-4 py-2 text-sm`}
                  >
                    {option.label}
                  </button>
                )}
              </MenuItem>
            ))}
          </div>
        </MenuItems>
      </Transition>
    </Menu>
  );
}
